/**
 * Pre/post programme diagnostic: admin per-track config, and the learner's
 * submission. Deliberately separate from assessment.ts even though it reuses
 * the same Question/QuestionBank authoring surface (QuestionBank.purpose =
 * DIAGNOSTIC) — no pass/fail, no retakes, one attempt per phase.
 */
import { z } from "zod";
export const DIAGNOSTIC_PHASES = ["PRE", "POST"];
export const diagnosticConfigSchema = z.object({
    bankId: z.string().min(1),
    questionCount: z.number().int().min(1).max(50).default(4),
    // Admin-configurable per phase, independently — see schema.prisma.
    requirePre: z.boolean().default(true),
    requirePost: z.boolean().default(true),
});
export const submitDiagnosticSchema = z.object({
    responses: z
        .array(z.object({
        questionId: z.string().min(1),
        selectedOptionIds: z.array(z.string().min(1)).max(10),
    }))
        .min(1)
        .max(50),
});
//# sourceMappingURL=diagnostic.js.map